import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/config";

const TOKEN_KEY = "cc_member_token";

export const useMember = () => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(!!token);

  useEffect(() => {
    if (!token) { setMember(null); setLoading(false); return; }
    axios.get(`${API}/members/me`, { headers: { "X-Member-Token": token } })
      .then((r) => setMember(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setToken(null); })
      .finally(() => setLoading(false));
  }, [token]);

  const signIn = (tok, m) => { localStorage.setItem(TOKEN_KEY, tok); setToken(tok); setMember(m); };
  const signOut = () => { localStorage.removeItem(TOKEN_KEY); setToken(null); setMember(null); };
  const headers = token ? { "X-Member-Token": token } : {};
  return { token, member, loading, signIn, signOut, setMember, headers };
};

/** Persist a form draft in localStorage so progress survives verification / refresh. */
export const useDraft = (key, initial) => {
  const [draft, setDraft] = useState(() => {
    try { return { ...initial, ...JSON.parse(localStorage.getItem(key) || "{}") }; } catch { return initial; }
  });
  useEffect(() => { localStorage.setItem(key, JSON.stringify(draft)); }, [key, draft]);
  const clear = () => { localStorage.removeItem(key); setDraft(initial); };
  return [draft, setDraft, clear];
};

export const errorMessage = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return fallback;
};
